import React, { useState } from "react";
import { MdModeEdit, MdDelete } from "react-icons/md";
import { BsFillEyeFill } from "react-icons/bs";
import { AiFillFile } from "react-icons/ai";
import { useParams } from "react-router";
import { Post } from "utils/request";
import { useDispatch } from "react-redux";
import { Show } from "actions/SnackbarActions";
import { Reorder, useDragControls } from "framer-motion";

import DefaultButton from "components/DefaultButton";
import SweetAlert from "react-bootstrap-sweetalert";
import DragHandleIcon from '@mui/icons-material/DragHandle';
import { IconButton } from "@mui/material";

const Board = props => {

    const {
        value,
        module_id,
        name,
        description,
        draggable = true,
        disponibility,
        onDelete = () => {}
    } = props;

    const [loading, SetLoading] = useState(false);
    const [popup, SetPopup] = useState(false);

    const { id } = useParams();
    const dragControls = useDragControls();
    const dispatch = useDispatch();

    const Delete = async () => {
        let form = new FormData();
        form.append("id", module_id);

        let response = await Post(`modules/delete`, form);

        if (response?.status === true) onDelete();

        dispatch(Show({
            message: response?.message,
            severity: response?.severity,
            show: true
        }));
    }

    return (
        <Reorder.Item
            value={value}
            dragListener={false}
            dragControls={dragControls}
            as="tr"
        >
            <IconButton
                component="td"
                onPointerDown={e => draggable && dragControls.start(e)}
                style={{
                    cursor: draggable ? "pointer" : "not-allowed",
                    touchAction: "pan-x"
                }}
            >
                <DragHandleIcon/>
            </IconButton>
            <td>{name}</td>
            <td>{disponibility} dia(s)</td>

            {/* <td className="table-text-dots">{description == "" ? "---" : description}</td> */}
            <td>
                <SweetAlert
                    warning
                    title={"Atenção"}
                    onConfirm={() => {
                        Delete();
                        SetPopup(false);
                    }}
                    onCancel={() => SetPopup(false)}
                    show={popup}
                    confirmBtnText='Deletar'
                    cancelBtnText='Cancelar'
                    confirmBtnBsStyle="primary"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                >
                    Tem certeza que deseja deletar esse módulo?
                </SweetAlert>
                <DefaultButton
                    to={`/modules/${module_id}/${id}`}
                    width="2.2em"
                    height="2.2em"
                    padding={0}
                    title={`Ver módulo`}
                    loading={loading}
                    bg="warning"
                    icon={<BsFillEyeFill size={17} color="white"/>}
                    style={{
                        marginRight: "2px"
                    }}
                />
                <DefaultButton
                    to={`/modules/${module_id}/${id}/edit`}
                    width="2.2em"
                    height="2.2em"
                    padding={0}
                    title={`Editar módulo`}
                    bg="info"
                    icon={<MdModeEdit color="white" size={17}/>}
                    style={{
                        margin: "0 2px"
                    }}
                />
                <DefaultButton
                    onClick={() => SetPopup(true)}
                    width="2.2em"
                    height="2.2em"
                    padding={0}
                    title={`Deletar módulo`}
                    bg="danger"
                    loading={loading}
                    icon={!loading && <MdDelete size={17} color="white"/>}
                />
            </td>
        </Reorder.Item>
    );
}

export default Board;